import React from 'react';
import { Background3D } from './components/Background3D';
import { ProfileCoin } from './components/ProfileCoin';
import { SocialLinks } from './components/SocialLinks';

const App: React.FC = () => {
  const profileData = {
    name: "Andrii Ovcharenko",
    tagline: "Software Developer",
    linkedIn: "https://www.linkedin.com/in/andriiovcharenko/",
    github: "https://github.com/illetid",
      // You can use:
      // 1. A local image: public/profile.jpg (then use imageUrl="/profile.jpg")
      // 2. A data URL (like the default below)
      // 3. An external URL
    imageUrl: "/pp.jpg"
  };

  return (
    <div className="app">
      <Background3D />
      <main className="content">
        <ProfileCoin
          name={profileData.name}
          imageUrl={profileData.imageUrl}
          size={250}
        />
        <div className="title-group">
          <h1>{profileData.name}</h1>
          <p className="tagline">{profileData.tagline}</p>
        </div>
        <SocialLinks
          linkedInUrl={profileData.linkedIn}
          githubUrl={profileData.github}
        />
      </main>
    </div>
  );
};

export default App;
